<template>
	<div id="qe_center1">
		<div class="cc-header">
			<div class="active_title">写实情况</div>
		</div>
		<div class="main-value" id="real_situ"></div>
		<div class="activity_block">
			<ul>
				<li style="width: 30%;">
					<div class="top_rotate">
						<div class="bg_rotate">
							<img width="100%" height="100%" src="../../assets/img/top_icon.png">
						</div>
						<div class="rotate_imgicon">
							<img width="100%" height="100%" src="../../assets/img/icon_01.gif">
						</div>
					</div>
					<div class="float-l icon mt01">
						<b>{{ count1 }}条</b><br>思想品德
					</div>
				</li>
				<li style="width: 30%;">
					<div class=" top_rotate">
						<div class="bg_rotate">
							<img width="100%" height="100%" src="../../assets/img/top_icon.png">
						</div>
						<div class="rotate_imgicon">
							<img width="100%" height="100%" src="../../assets/img/icon_02.gif">
						</div>
					</div>
					<div class="float-l icon mt01">
						<b>{{ count2 }}条</b><br>学业水平
					</div>
				</li>
				<li style="width: 38%;">
					<div class=" top_rotate">
						<div class="bg_rotate">
							<img width="100%" height="100%" src="../../assets/img/top_icon.png">
						</div>
						<div class="rotate_imgicon">
							<img width="100%" height="100%" src="../../assets/img/icon_03.gif">
						</div>
					</div>
					<div class="float-l icon mt01">
						<b>{{ count3 }}条</b><br>身心健康
					</div>
				</li>
				<li style="width: 30%;">
					<div class=" top_rotate">
						<div class="bg_rotate">
							<img width="100%" height="100%" src="../../assets/img/top_icon.png">
						</div>
						<div class="rotate_imgicon">
							<img width="100%" height="100%" src="../../assets/img/icon_04.gif">
						</div>
					</div>
					<div class="float-l icon mt01">
						<b>{{ count4 }}条</b><br>艺术素养
					</div>
				</li>
				<li style="width: 30%;">
					<div class="top_rotate">
						<div class="bg_rotate">
							<img width="100%" height="100%" src="../../assets/img/top_icon.png">
						</div>
						<div class="rotate_imgicon">
							<img width="100%" height="100%" src="../../assets/img/icon_05.gif">
						</div>
					</div>
					<div class="float-l icon mt01">
						<b>{{ count5 }}条</b><br>社会实践
					</div>
				</li>
				<li style="width: 38%;">
					<div class=" top_rotate">
						<div class="bg_rotate">
							<img width="100%" height="100%" src="../../assets/img/top_icon.png">
						</div>
						<div class="rotate_imgicon">
							<img width="100%" height="100%" src="../../assets/img/icon_06.gif">
						</div>
					</div>
					<div class="float-l icon mt01">
						<b>{{ count6 }}条</b><br>典型事实材料及证明
					</div>
				</li>
			</ul>
		</div>
	</div>
</template>
<script>
var storage = window.localStorage;
var orgCode = storage.getItem("orgCode");
const echarts = require("echarts");
export default {
	data() {
		return {
			count1: 0,
			count2: 0,
			count3: 0,
			count4: 0,
			count5: 0,
			count6: 0
		};
	},
	mounted() {
		this.initData();
		// 定时器刷新，1小时
		let _this = this;
		setInterval(() => {
			_this.initData();
		}, 1000 * 60 * 60);
	},
	methods: {
		initData() {
			let _this = this;
			// 基于准备好的dom，初始化echarts实例
			let activityCount = echarts.init(document.getElementById("real_situ"));
			this.$http.get("/dataView/quality/edu/getRealCountByType?orgCode=" + orgCode + "&termName=" + _this.$parent.$parent.$parent.termName).then(res => {
				if (res.data.code === 200) {
					var result = res.data.result;
					var data = [];
					for (var i = 0; i < result.length; i++) {
						data.push({ name: result[i].typeName, value: result[i].typeCount });
						if (result[i].typeName == '思想品德') {
							_this.count1 = result[i].typeCount;
						} else if (result[i].typeName == '学业水平') {
							_this.count2 = result[i].typeCount;
						} else if (result[i].typeName == '身心健康') {
							_this.count3 = result[i].typeCount;
						} else if (result[i].typeName == '艺术素养') {
							_this.count4 = result[i].typeCount;
						} else if (result[i].typeName == '社会实践') {
							_this.count5 = result[i].typeCount;
						} else if (result[i].typeName == '典型事实材料及证明') {
							_this.count6 = result[i].typeCount;
						}
					}
					var option = {
						tooltip: {
							trigger: 'item',
							formatter: function (params) {
								var relVal = '写实记录<br/>' + params.marker + '&nbsp;' + params.name + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>' + params.value + '</b>条';
								return relVal
							}
						},
						legend: {
							show: false,
							textStyle: {
								fontSize: fontSize(0.15),
								height: 13,
								rich: { a: { verticalAlign: 'middle' } },
								color: '#55ffff' // 把颜色这里做成函数就可以了
							},
							bottom: '0',
							itemWidth: 20,
							itemHeight: 13
						},
						series: [{
							name: '写实记录',
							type: 'pie',
							radius: '60%',
							center: ['50%', '50%'],
							labelLine: {
								normal: {
									length: 15,
									length2: 10
								}
							},
							label: {
								normal: {
									padding: [0, 5],
									formatter: function (p) {
										return p.name + ' : ' + p.value + '条(' + p.percent + "%)";
									}
								}
							},
							data: data,
							itemStyle: {
								normal: {
									label: {
										textStyle: {
											color: '#55ffff',
											lineHeight: 18,
											fontSize: fontSize(0.15)
										}
									}
								}
							},
							emphasis: {
								itemStyle: {
									shadowBlur: 10,
									shadowOffsetX: 0,
									shadowColor: 'rgba(0, 0, 0, 0.5)'
								}
							}
						}]
					};
					activityCount.setOption(option);
					// 响应式变化
					window.addEventListener("resize", () => activityCount.resize(), false);
				}
			})
		}
	},
	destroyed() {
		window.onresize = null;
	}
};

function fontSize(res) {
	let clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	if (!clientWidth) return;
	let fontSize = 100 * (clientWidth / 1920);
	return res * fontSize;
}
</script>

<style lang="scss">
#qe_center1 {
	height: 100%;
	padding: 0 3%;

	.cc-header {
		width: 100%;
		color: #55ffff;
		text-align: center;
		font-size: 0.25rem;
		padding-top: 0.2rem;
	}

	.activity_block {
		width: 100%;
		margin-left: 0.6rem;
		margin-top: -10px;
	}

	.activity_block ul {
		width: 100%;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		flex-wrap: wrap;
	}

	.activity_block li {
		font-size: 0.19rem;
		margin-bottom: 0.15rem;
		color: #54beff;
		overflow: hidden;
	}

	.activity_block li .icon {
		margin-left: 0.1rem;
	}

	.activity_block li .icon img {
		width: 25px;
		height: 25px;
	}

	.activity_block li b {
		color: #55ffff
	}

	.mt01 {
		margin-top: 0.1rem;
	}

	.main-value {
		height: 60%;
	}

	.rotate_bgicon {
		width: 1.2rem;
		height: 1.2rem;
		position: relative;
	}

	.top_rotate {
		position: relative;
		float: left;
		width: 0.9rem;
		height: 0.9rem
	}

	.bg_rotate {
		position: absolute;
		top: 0;
		left: 0
	}

	.bg_rotate img {
		animation: rotate01 2s linear infinite;
	}

	@keyframes rotate01 {

		/* css事件 animation: rotate01 2s linear infinite;*/
		0% {
			transform: rotate(0deg);
		}

		100% {
			transform: rotate(360deg);

			/* 可配置跳动方向 */
		}
	}

	.rotate_imgicon {
		width: 0.45rem;
		position: absolute;
		top: 0.23rem;
		left: 0.23rem;
	}
}</style>
